import React, { useState, useEffect } from 'react'
import { Box, styled } from '@mui/system'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Alert from '@mui/material/Alert'
import { ToastContainer } from 'react-toastify'
import { Apis } from 'app/Apis/Apis'
import { useNavigate } from 'react-router-dom'
import { Switch } from '@mui/material'
const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const AddLocation = () => {
    const [statusValue, setStatusValue] = useState(false)
    const [alldata, setAllData] = useState({
        area: '',
        latitude: '',
        longitude: '',
        gMapsLink: '',
        status: '',
        radiusServed: '',
    })
    const [message, setMessage] = useState()
    const navigate = useNavigate()

    const handleChange = (e) => {
        setAllData({
            ...alldata,
            [e.target.name]: e.target.value,
        })
    }

    const handleSubmit = () => {
        const formdata = {
            status: statusValue,
            area: alldata.area,
            gMapsLink: alldata.gMapsLink,
            radius: alldata.radiusServed,
            gpsCoordinates: {
                latitude: alldata.latitude,
                longitude: alldata.longitude,
            },
        }

        let config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
        }

        if (
            !alldata.area ||
            !alldata.longitude ||
            !alldata.latitude ||
            !alldata.gMapsLink ||
            !alldata.radiusServed ||
            !alldata.status
        ) {
            if (!alldata.area) {
                setMessage('Area is required !')
            } else {
                if (!alldata.longitude) {
                    setMessage('Longitude is required !')
                } else {
                    if (!alldata.gMapsLink) {
                        setMessage('Google maps link is required !')
                    } else {
                        if (!alldata.radiusServed) {
                            setMessage('Radius served is required !')
                        } else {
                            {
                                axios
                                    .post(
                                        `${Apis.addLocation}`,
                                        formdata,
                                        config
                                    )
                                    .then((res) => {
                                        console.log(
                                            'message in Add location',
                                            res?.data?.code
                                        )

                                        setMessage([
                                            res?.data?.message ||
                                                'Location added successfully',
                                            res?.data?.code,
                                        ])
                                        setTimeout(() => {
                                            navigate('/dashboard/location')
                                        }, 2000)
                                    })
                                    .catch((err) => {
                                        console.log(
                                            'Error in Add location',
                                            err?.response?.data
                                        )
                                        setMessage(err?.response?.data?.message)
                                    })
                            }
                        }
                    }
                }
            }
        }

        setTimeout(() => {}, 2000)
    }

    return (
        <Container>
            {message ? (
                <Alert
                    severity={message[1] === 200 ? 'success' : 'error'}
                    sx={{ position: 'fixed', width: '80%' }}
                >
                    {message.length === 2 ? message[0] : message}
                </Alert>
            ) : (
                ''
            )}
            <Link to={'/dashboard/location'}>
                <Box sx={{ padding: '15px 0px' }}>
                    <ArrowBackIcon />
                </Box>
            </Link>

            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    marginBottom: 5,
                    fontWeight: 500,
                    fontSize: 20,
                }}
            >
                Add a new location
            </Box>
            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    width: '110%',
                }}
            >
                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Area / Zone</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Area / Zone"
                            type="text"
                            name="area"
                            onChange={handleChange}
                            autoComplete="current-password"
                            sx={{ padding: 0, width: '30vh' }}
                        />{' '}
                    </Box>
                </Box>

                <Box sx={{ display: 'flex' }}>
                    <Box sx={{ width: '30%' }}>GPS coordinates</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                paddingBottom: 1,
                            }}
                        >
                            <TextField
                                id="outlined-password-input"
                                label="Latitude"
                                type="number"
                                name="latitude"
                                onChange={handleChange}
                                sx={{ paddingBottom: 1, width: '30vh' }}
                                autoComplete="current-password"
                            />

                            <TextField
                                id="outlined-password-input"
                                label="Longitude"
                                type="number"
                                name="longitude"
                                onChange={handleChange}
                                sx={{ paddingBottom: 1, width: '30vh' }}
                                autoComplete="current-password"
                            />
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Google maps link</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Google maps link"
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            type="text"
                            name="gMapsLink"
                            onChange={handleChange}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Radius served (KM)</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Radius served"
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            type="number"
                            name="radiusServed"
                            onChange={handleChange}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Activate area</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <Switch
                            checked={statusValue ? true : false}
                            value=""
                            onClick={(e) => {
                                setStatusValue(!statusValue)
                            }}
                        />
                    </Box>
                </Box>
            </Box>
            <Button
                variant="contained"
                sx={{ marginTop: 3 }}
                onClick={handleSubmit}
            >
                Submit
            </Button>

            <ToastContainer />
        </Container>
    )
}

export default AddLocation
